// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".semi-ring-chart {\n\ttop: 6vh;\n}\n\n.semi-ring-chart > svg {\n\twidth: 20vw;\n}", "",{"version":3,"sources":["webpack://src/components/Recharts/SemiRingChart/index.css"],"names":[],"mappings":"AAAA;CACC,QAAQ;AACT;;AAEA;CACC,WAAW;AACZ","sourcesContent":[".semi-ring-chart {\n\ttop: 6vh;\n}\n\n.semi-ring-chart > svg {\n\twidth: 20vw;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
